<template>
    <v-list nav dense>
        <template>
            <v-list-item link router to="/home" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('inicio') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/golf" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-golf</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        Golf
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/notices" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-bullhorn</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Notices') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/settings" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('configuracion') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Ayuda') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'starter',
  computed: {
    ...mapGetters(['getProfile'])
  }
}
</script>

<style scoped>
.list:hover {
    background: white;
    opacity: 0.85;
}
</style>
